import { gql } from "@apollo/client";

const GET_INTELLI_UPLOAD_HISTORY = gql`
  query GetIntelliUploadHistory($params: IntelliUploadQueueListInput!) {
    queueList(params: $params) {
      total
      page
      limit
      items {
        queueId
        processId
        isQueueCompleted
        isRuleTriggered
        createdAt
        documentsCount
        status
      }
    }
  }
`;

export default GET_INTELLI_UPLOAD_HISTORY;